import React, { Component } from "react";
import { OfficialRating } from "../../../../types";
import { deleteLicense, getOfficialRating, validateLicense, mapLicense } from "../../../../actions";
import { _ } from "libs";
import { Field, Form } from "react-final-form";
import DoBSelect from "../dobSelect";
import RatingSelect from "../ratingSelect";

class SwissCountryFields extends Component<
	{
		country: string;
		onRatingChange: any;
		rating: any;
		ratings: Array<any>;
		disabled?: boolean;
		officialRating?: OfficialRating;
		userId: string;
		onResetClicked;
		onSaveClicked;
	},
	{
		officialRating: OfficialRating;
		stRating: { licenseNumber: string; classificationCategory: string };
		loaded: boolean;
		licenseNumber?: string;
		rating?: string;
		licenseChanged: boolean;
		birthDate: string;
	}
> {
	constructor(props) {
		super(props);

		this.state = {
			officialRating: null,
			stRating: null,
			loaded: false,
			licenseNumber: null,
			rating: props.rating,
			licenseChanged: false,
			birthDate: null,
		};
	}

	componentDidMount() {
		if (this.props.officialRating && this.props.officialRating.code) {
			getOfficialRating(this.props.userId, this.props.officialRating.code, true).then((result) => {
				if (result && result.rating) {
					this.setState({
						stRating: result.rating,
						licenseNumber: result.rating.licenseNumber,
						loaded: true,
						rating: result.rating.classificationCategory,
					});
					this.props.onRatingChange(result.rating.classificationCategory);
				}
				else {
					this.setState({
						...this.state,
						loaded: true,
					});
				}
			});
		} else {
			this.setState({ loaded: true });
		}
	}

	private validateLicenseInput = (value) => {
		if (!value) {
			return undefined;
		}

		return /(\d{1,3}\.){3}\d{1,3}$/g.test(value) ? undefined : _("form.stLicense.wrongLicenseFormat");
	};

	mapLicense = async () => {
		if (this.state.birthDate !== null && this.state.licenseNumber !== null) {
			const result: any = await mapLicense("st", this.state.birthDate, this.state.licenseNumber);
		}
		if (!this.state.licenseNumber) {
			if (this.state.officialRating && this.state.officialRating.code) {
				await deleteLicense(this.state.officialRating.code);
			}
		}
	};

	async validateFederationsLicense(licenseNumber: string, birthDate: string) {
		this.setState({
			loaded: false,
		});
		const result: any = await validateLicense("st", birthDate, licenseNumber);
		let newState: any = {
			loaded: true,
			rating: null,
		};
		if (result && result.rating) {
			newState.stRating = {
				licenseNumber: result.rating.licenceNumber,
				classificationCategory: result.rating.classificationCategory,
			};
			newState.officialRating = {
				code: result.rating.federationCode,
				name: result.rating.federationName,
			};
			newState.rating = result.rating.classificationCategory;
			this.props.onRatingChange(result.rating.classificationCategory);
		}
		this.setState(newState);
	}

	private onLicenseAndDobChange = async (licenseNumber, dob) => {
		this.setState({
			licenseNumber: licenseNumber,
			birthDate: dob,
		});

		if (this.state.loaded && licenseNumber && !this.validateDob(dob, licenseNumber)) {
			await this.validateFederationsLicense(licenseNumber, dob);
		}
	};

	private onRatingChange = (value, officialRating?: OfficialRating) => {
		this.props.onRatingChange(value, officialRating);
		this.setState({
			rating: value,
		});
	};

	private isRatingFieldDisabled(): boolean {
		if (!this.state.loaded) {
			return true;
		}

		if (this.state.licenseNumber) {
			return true;
		}

		if (this.state.stRating && !this.state.licenseNumber) {
			return false;
		}
		return false;
	}

	private isSaveDisabled(): boolean {
		if (!this.state.loaded) {
			return true;
		}

		if (!this.state.rating) {
			return true;
		}
		return false;
	}

	private validateDob = (value, licenseNumber) => {
		if (!value && !licenseNumber) {
			return undefined;
		}

		return /^\d{4}-\d{2}-\d{2}$/g.test(value) ? undefined : _("onboarding.profileForm.st.birthdayMissing");
	};

	private parseDob(value: number[], name): string {
		if (value === null) {
			value = [null, null, null];
		}

		const [day, month, year] = value;

		return `${year}-${month}-${day <= 9 ? "0" + day : day}`;
	}

	private formatDob(value: string): { day: string | number; month: string | number; year: string | number } {
		let [day, month, year] = [null, null, null];
		if (value) {
			[year, month, day] = value.split("-");
		}

		day = day && day <= 9 && day.length === 1 ? "0" + day : day;

		return { day, month, year };
	}

	render() {
		return (
			<Form
				onSubmit={async (values: any) => {
					await this.mapLicense();
					this.onRatingChange(this.state.rating, this.state.officialRating);
					this.props.onSaveClicked();
				}}
				render={({ handleSubmit, submitting, pristine, invalid, values, valid }) => (
					<form onSubmit={handleSubmit}>
						<Field
							name="stLicenceNumber"
							validate={this.validateLicenseInput}
							initialValue={this.state.licenseNumber}
						>
							{({ input, meta }) => (
								<div className="field medium">
									<label>
										{_("form.stLicense.label")} ({_("optional.placeholder")})
									</label>
									<input
										{...input}
										type="text"
										placeholder={_("form.stLicense.placeholder")}
										value={this.state.licenseNumber || ""}
										onChange={(event) => {
											this.onLicenseAndDobChange(event.target.value, values.dob);
											input.onChange(event);
										}}
									/>
									{meta.error && meta.touched && <p className="error">{meta.error}</p>}
									<div className="note">{_("form.stLicense.description")}</div>
								</div>
							)}
						</Field>
						{values.stLicenceNumber && !this.validateLicenseInput(values.stLicenceNumber) && (
							<Field
								name="dob"
								parse={this.parseDob}
								format={this.formatDob}
								validate={(value, allValues: any) => this.validateDob(value, allValues.stLicenceNumber)}
							>
								{({ input, meta, ...rest }) => (
									<div className="field medium">
										<label>{_("onboarding.profileForm.dob.label")}</label>
										<DoBSelect
											{...{ input, meta, ...rest }}
											dayPrompt={_("onboarding.profileForm.dob.dayPrompt")}
											monthPrompt={_("onboarding.profileForm.dob.monthPrompt")}
											yearPrompt={_("onboarding.profileForm.dob.yearPrompt")}
											customOnChange={(dob) =>
												this.onLicenseAndDobChange(
													values.stLicenceNumber,
													this.parseDob(dob, "")
												)
											}
										/>
										{meta.touched && meta.error && <p className="error">{meta.error}</p>}
									</div>
								)}
							</Field>
						)}

						<div className="field medium">
							<label>{_("form.rating.label")}</label>
							{this.state.loaded && (
								<RatingSelect
									country={this.props.country}
									onRatingChange={this.onRatingChange}
									rating={this.state.rating}
									ratings={this.props.ratings}
									disabled={this.isRatingFieldDisabled()}
								/>
							)}
							{!this.state.loaded && (
								<Field component="select" name="loading" disabled={true}>
									<option>{_("loader.defaultText")}</option>
								</Field>
							)}
						</div>
						<button className="button submit" disabled={!valid || submitting || this.isSaveDisabled()}>
							{_("onboarding.nationalRating.btnSave.label")}
						</button>
					</form>
				)}
			/>
		);
	}
}

export default SwissCountryFields;
